module.exports = __webpack_public_path__ + "img/alert-icon.ffebdb9c.svg";